(() => {
  function evaluateOffer(cart, offer, offers = []) {
    if (!offer || offer.seen || !offer.available || !Number.isInteger(offer.stock) || offer.stock < 4) return null;
    const lines = cart.items.filter((item) => item.variant_id === offer.variantId);
    if (lines.some((item) => item.product_id !== offer.productId || item.selling_plan_allocation
      || Object.keys(item.properties || {}).length || item.total_discount > 0)) return null;
    if (cart.cart_level_discount_applications?.length || cart.discount_codes?.some((code) => code.applicable)) return null;
    const otherDiscountedLines = cart.items.filter((item) => item.variant_id !== offer.variantId
      && (item.total_discount > 0 || item.line_level_discount_allocations?.length));
    if (otherDiscountedLines.length && !offer.canCombine) return null;
    if (otherDiscountedLines.some((item) => {
      const compatible = offers.find((entry) => entry.variantId === item.variant_id && entry.productId === item.product_id);
      const allocations = item.line_level_discount_allocations || [];
      return !compatible?.canCombine || !allocations.length || allocations.some((allocation) =>
        allocation.discount_application?.type !== 'automatic'
        || allocation.discount_application?.value_type !== 'percentage'
        || Number(allocation.discount_application?.value) !== 100
        || !compatible.discountTitles.includes(allocation.discount_application?.title));
    })) return null;
    const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity >= 4) return null;
    return { quantity, add: 4 - quantity, paid: 3 - quantity, additionalPrice: (3 - quantity) * offer.price };
  }
  function qualifiesForFreeShipping(cart, additionalPrice) {
    return cart?.currency === 'USD' && Number.isSafeInteger(cart.total_price)
      && Number.isSafeInteger(additionalPrice) && additionalPrice >= 0
      && cart.total_price + additionalPrice > 11900;
  }
  function createAcceptance({ readState, add, readCart }) {
    let busy = false;
    let finished = false;
    return async (expected) => {
      if (busy) return { status: 'busy' };
      if (finished) return { status: 'finished' };
      busy = true;
      try {
        const { cart, offer, offers } = await readState();
        const decision = evaluateOffer(cart, offer, offers);
        if (!decision) return { status: 'ineligible' };
        if (decision.quantity !== expected.quantity || decision.additionalPrice !== expected.additionalPrice
          || (typeof expected.freeShipping === 'boolean'
            && expected.freeShipping !== qualifiesForFreeShipping(cart, decision.additionalPrice))) {
          return { status: 'changed', decision, offer, cart };
        }
        finished = true;
        await add(offer.variantId, decision.add);
        const updated = await readCart();
        const lines = updated.items.filter((item) => item.variant_id === offer.variantId);
        const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
        // Buy-X-get-Y metadata need not describe the benefit as 100% off.
        // Confirm the named offer and actual four-for-three prices, including split lines.
        const validPrices = lines.every((item) => item.product_id === offer.productId
          && Number.isSafeInteger(item.original_line_price) && item.original_line_price >= 0
          && Number.isSafeInteger(item.final_line_price) && item.final_line_price >= 0);
        const original = lines.reduce((sum, item) => sum + item.original_line_price, 0);
        const final = lines.reduce((sum, item) => sum + item.final_line_price, 0);
        const free = lines.reduce((sum, item) => sum + (item.line_level_discount_allocations || [])
          .filter((allocation) => offer.discountTitles.includes(allocation.discount_application?.title))
          .reduce((total, allocation) => total + allocation.amount, 0), 0);
        const applied = quantity === 4 && validPrices && original === 4 * offer.price
          && final === 3 * offer.price && free === offer.price;
        return { status: applied ? 'applied' : 'discount-missing', cart: updated };
      } catch (error) {
        let cart;
        if (finished) {
          try { cart = await readCart(); } catch (reconciliationError) {}
        }
        return { status: finished ? 'uncertain' : 'unavailable', cart };
      } finally {
        busy = false;
      }
    };
  }
  const api = { evaluateOffer, createAcceptance, qualifiesForFreeShipping };
  if (typeof module !== 'undefined') module.exports = api;
  else window.RIFoiCore = api;
})();
